import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { BreedGroupApi, BreedGroupSearch, BreedGroupGridDto } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { useGlobalData } from "../../../../contexts";

export interface IBreedGroupsListPageProps {}

export const BreedGroupsListPage: React.FunctionComponent<IBreedGroupsListPageProps> = (props) => {
  const breedGroupApi = useApiService(BreedGroupApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: BreedGroupGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.breedGroups}/${row.breedGroupId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.breedGroups}/${row.breedGroupId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.BreedGroupNumber),
        fieldName: "breedGroupNumber",
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.breedGroups}/0/detail/edit`);
  }, [history]);

  const searchFunction = React.useCallback(
    (sObj) => breedGroupApi.baseSearch(BreedGroupSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [breedGroupApi, currentLanguage.languageId]
  );

  const exportFunction = React.useCallback(
    (sObj) => breedGroupApi.exportXlsFile(BreedGroupSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [breedGroupApi, currentLanguage.languageId]
  );

  const searchCriteriasFunction = React.useCallback(() => breedGroupApi.getSearchCriterias(true), [breedGroupApi]);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={searchCriteriasFunction}
      searchFunction={searchFunction}
      exportFunction={exportFunction}
      addFunc={addItemFunction}
      sortKeys={{ breedGroupNumber: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.BreedGroups) }]}
    />
  );
};
